<div class="community-message-compose container-xl py-3" *transloco="let t">
  <header class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h1 class="h3 mb-0">{{ t('community.messages.new') }}</h1>
    <a class="btn btn-outline-secondary btn-sm" [routerLink]="backLink()">← {{ t('community.messages.back_to_list') }}</a>
  </header>

  @if (loading()) {
    <div class="text-center py-4"><div class="spinner-border" role="status"></div></div>
  } @else if (loadError(); as key) {
    <div class="alert alert-danger">{{ t(key) }}</div>
  } @else if (messagingMuted()) {
    <div class="alert alert-warning">{{ t('community.errors.community_muted') }}</div>
  } @else {
    @if (error(); as key) {
      <div class="alert alert-danger d-flex justify-content-between align-items-start">
        <span>{{ t(key) }}</span>
        <button type="button" class="btn-close" (click)="error.set(null)"></button>
      </div>
    }

    <div class="card">
      <div class="card-body">
        <div class="mb-3 position-relative">
          <label class="form-label">{{ t('community.messages.recipient') }} *</label>

          @if (isAdmin()) {
            <input type="text" class="form-control" autocomplete="off"
                   [placeholder]="t('community.messages.recipient_search_placeholder')"
                   [ngModel]="searchTerm" (ngModelChange)="onSearch($event)" />
            @if (searchResults().length > 0) {
              <ul class="list-group community-message-compose__results">
                @for (r of searchResults(); track r.id) {
                  <li class="list-group-item list-group-item-action py-1" role="button" (click)="pick(r)">
                    <app-community-avatar [user]="r" [size]="24" class="me-2" />
                    {{ r.display_label }}
                  </li>
                }
              </ul>
            }
            @if (recipient(); as picked) {
              <div class="form-text">✓ {{ picked.display_label }}</div>
            }
          } @else if (recipients().length === 0) {
            <p class="text-muted small">{{ t('community.messages.no_recipients') }}</p>
          } @else {
            <select class="form-select" [ngModel]="recipientId() ?? ''" (ngModelChange)="selectRecipient($event)">
              <option value="" disabled>{{ t('community.messages.recipient_select') }}</option>
              @for (r of recipients(); track r.id) {
                <option [ngValue]="r.id">{{ r.display_label }}</option>
              }
            </select>
          }
        </div>

        <div class="mb-3">
          <label class="form-label">{{ t('community.messages.subject') }} *</label>
          <input type="text" class="form-control" maxlength="255" [(ngModel)]="subject" />
        </div>

        <div class="mb-3">
          <label class="form-label">{{ t('community.messages.content') }} *</label>
          <textarea class="form-control" rows="8" [(ngModel)]="content"></textarea>
        </div>

        <div class="d-flex gap-2">
          <button type="button" class="btn btn-primary" [disabled]="sending() || !canSend()" (click)="send()">
            @if (sending()) { <span class="spinner-border spinner-border-sm me-1" role="status"></span> }
            {{ t('community.messages.send') }}
          </button>
          <a class="btn btn-outline-secondary" [routerLink]="backLink()">{{ t('community.threads.cancel') }}</a>
        </div>
      </div>
    </div>
  }
</div>
